/** 画面で起きた想定外のエラーの送り先。Sentry を入れるときはここで captureException を呼ぶ */
type Reporter = (error: unknown, context?: Record<string, unknown>) => void;

let reporter: Reporter = (error, context) => console.error("画面のエラー", error, context);

export function setErrorReporter(fn: Reporter) {
  reporter = fn;
}

export function reportError(error: unknown, context?: Record<string, unknown>) {
  try {
    reporter(error, context);
  } catch {
    // 送り先の失敗で画面を止めない
  }
}
